import dunegql from "src/utils/dunegqlCodegen/dunegql";
import {
  QueryAlertsDocument,
  useQueryAlertsQuery,
} from "src/gql/codegen/duneGraphql";
import { isNullable } from "src/utils/types/types";
import { SessionWithUser } from "src/utils/users/types";
import { QuerySchedule } from "./useQuerySchedule";

export const getQueryAlertsQueryOptions = (
  session: SessionWithUser,
  cronJobId: string
) => ({
  query: QueryAlertsDocument,
  variables: { cronJobId },
  context: { session },
});

export const useQueryAlert = (
  session: SessionWithUser,
  existingSchedule: QuerySchedule | undefined
) => {
  const result = useQueryAlertsQuery({
    skip: isNullable(existingSchedule),
    ...getQueryAlertsQueryOptions(session, existingSchedule?.id as string),
  });
  return result.data?.queryAlerts;
};

dunegql`
  query QueryAlerts($cronJobId: String!) {
    queryAlerts(cronJobId: $cronJobId) {
      email {
        id
        emails
      }
      slack {
        id
        url
      }
      webhook {
        id
        url
        dataFieldName
        httpHeaders
        jsonPayloadFields
      }
    }
  }
`;
